import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, BarChart3, Star, Users, Heart } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { getWishlist, toggleWishlist } from '@/lib/data';
import Tilt3DCard from '../effects/Tilt3DCard';
import ScrollReveal from '../effects/ScrollReveal';

const courseImages = {
  'course-1': 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&q=80',
  'course-2': 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=600&q=80',
  'course-3': 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=600&q=80',
  'course-4': 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&q=80',
  'course-5': 'https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=600&q=80',
  'course-6': 'https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=600&q=80',
  'course-7': 'https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=600&q=80',
  'course-8': 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=600&q=80',
  'course-9': 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&q=80',
};

export default function CourseCard({ course, index = 0 }) {
  const [wishlisted, setWishlisted] = React.useState(getWishlist().includes(course.id));

  const handleWishlist = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(course.id);
    setWishlisted(!wishlisted);
  };

  const levelColors = {
    'Beginner': 'bg-green-100 text-green-700',
    'Intermediate': 'bg-blue-100 text-blue-700',
    'Advanced': 'bg-purple-100 text-purple-700',
  };

  return (
    <ScrollReveal variant="fadeUp" delay={index * 0.08}>
      <Tilt3DCard intensity={10}>
        <Link to={`/course/${course.id}`} className="block group">
          <div className="bg-card rounded-xl border overflow-hidden hover:shadow-2xl transition-shadow duration-400">
            {/* Thumbnail */}
            <div className="relative aspect-video overflow-hidden">
              <motion.img
                src={course.image_url || courseImages[course.id] || 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&q=80'}
                alt={course.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              {/* <div className="absolute top-3 left-3">
                <Badge className={`${levelColors[course.level]} text-xs font-medium border-0`}>{course.level}</Badge>
              </div> */}
              {/* <motion.button
                onClick={handleWishlist}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.85 }}
                className="absolute top-3 right-3 w-8 h-8 rounded-full bg-card/80 backdrop-blur-sm flex items-center justify-center hover:bg-card transition-colors"
              >
                <motion.div
                  animate={wishlisted ? { scale: [1, 1.4, 1] } : {}}
                  transition={{ duration: 0.3 }}
                >
                  <Heart className={`w-4 h-4 ${wishlisted ? 'fill-red-500 text-red-500' : 'text-muted-foreground'}`} />
                </motion.div>
              </motion.button> */}
            </div>

            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                {course.tags.slice(0, 2).map(tag => (
                  <span key={tag} className="text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded-full">{tag}</span>
                ))}
              </div>
              <h3 className="font-heading font-semibold text-base group-hover:text-primary transition-colors line-clamp-2 min-h-[2.5rem]">
                {course.title}
              </h3>
              <p className="text-sm text-muted-foreground mt-1.5 line-clamp-2">{course.shortDescription}</p>

              <div className="flex items-center gap-4 mt-3 text-xs text-muted-foreground">
                <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" />{course.duration}</span>
                {/* <span className="flex items-center gap-1"><BarChart3 className="w-3.5 h-3.5" />{course.level}</span> */}
                <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" />{(course.students / 1000).toFixed(1)}K</span>
              </div>

              <div className="flex items-center justify-between mt-4 pt-3 border-t">
                <div className="flex items-center gap-1.5">
                  <motion.div whileHover={{ scale: 1.2, rotate: 20 }}>
                    <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
                  </motion.div>
                  <span className="text-sm font-semibold">{course.rating}</span>
                  <span className="text-xs text-muted-foreground">({course?.review_count})</span>
                </div>
                <div className="flex items-center gap-2">
                  {/* <span className="text-xs text-muted-foreground line-through">₹{course.originalPrice.toLocaleString('en-IN')}</span>
                  <motion.span
                    whileHover={{ scale: 1.1 }}
                    className="text-lg font-heading font-bold text-primary"
                  >
                    ₹{course.price.toLocaleString('en-IN')}
                  </motion.span> */}
                </div>
              </div>
            </div>
          </div>
        </Link>
      </Tilt3DCard>
    </ScrollReveal>
  );
}